import React from 'react'
import { makeStyles, useDialogs, useIsMobile, Button, Hidden, useClientOptions } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import AddIcon from '@material-ui/icons/Add'
import CreateLocationDialog from 'src/components/dialogs/CreateLocationDialog'
import { getObjectLabels } from '@paintscout/util/builder'

const useStyles = makeStyles<Theme, NewLocationButtonProps>(
  (_theme) => ({
    root: {}
  }),
  { name: 'NewLocationButton' }
)

export interface NewLocationButtonProps {
  classes?: StyleClasses<typeof useStyles>
}

function NewLocationButton(props: NewLocationButtonProps) {
  const classes = useStyles(props)
  const { openDialog, dismissDialog } = useDialogs()
  const isMobile = useIsMobile()
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })

  return (
    <div className={classes.root}>
      <Button
        {...props}
        icon={AddIcon}
        onClick={() => {
          openDialog(CreateLocationDialog, {
            onConfirm: dismissDialog,
            onCancel: dismissDialog
          })
        }}
        size={isMobile ? 'large' : 'medium'}
      >
        <>
          New <Hidden mdDown={true}>{objectLabels.locations.value}</Hidden>
        </>
      </Button>
    </div>
  )
}

export default NewLocationButton
